<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :row-class-name="rowClassName"
      :columns="tableColumns"
      :height="tableHeight"
      size="mini"
      :expand-config="{ reserve: true }"
      resizable
      border
      row-id="orderBatchCode"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
      :header-cell-style="headerCellStyle"
    >
      <template v-slot:toolbar_form>
        <div class="side-frame-warning">
          <span style="font-size: 18px; color: #606266">{{
            $l('INDEX.order_tab_delivery_batch') || '交货批次'
          }}</span>

          <el-divider direction="vertical"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            @click="batchDel()"
          >
            <i class="el-icon-delete"></i>
            {{ $l('INDEX.btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:errorMsg="{ row }">
        <div>
          <span v-html="row.errorMsg"></span>
        </div>
      </template>

      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <i class="el-icon-delete tool-btn" @click="del(row)"></i>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {},
  mixins: [EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    errorKeys: { type: Array, default: () => [] },
    tableHeight: { type: Number, default: 400 },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      rowClassName: ({ row }) => {
        const { orderBatchCode } = row
        if (!this.errorKeys || !this.errorKeys.length) return ''
        const index = this.errorKeys.findIndex((key) => key === orderBatchCode)
        return index < 0 ? '' : 'bg-danger text-white'
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'left',
          width: 60,
          slots: {
            default: 'opt',
          },
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_orderBatchNo') ||
            '交货批次号',
          field: 'orderBatchNo',
          headerAlign: 'center',
          align: 'center',
          fixed: 'left',
          minWidth: 150,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.order_form_label_orderNo') || '订单编号',
          field: 'orderNo',
          width: 150,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.order_form_label_custOrderNo') || '客户订单编号',
          field: 'custOrderNo',
          width: 150,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_shipmentStartDate') ||
            '客户最早交期',
          field: 'shipmentDate',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_shipmentEndDate') ||
            '客户最晚交期',
          field: 'shipmentEndDate',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.table_label_cargoReadyDay') || '货好时间',
          field: 'cargoReadyDay',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('form_batch_verification_error') || '批次校验错误',
          field: 'errorMsg',
          headerAlign: 'center',
          align: 'left',
          minWidth: 180,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
          slots: { default: 'errorMsg' },
        },
        {
          title: this.$l('INDEX.order_form_label_retailerPo') || '零售商PO',
          field: 'retailerPo',
          headerAlign: 'center',
          align: 'left',
          minWidth: 150,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('INDEX.order_form_label_importerPo') || '代理商PO',
          field: 'importerPo',
          headerAlign: 'center',
          align: 'left',
          minWidth: 150,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_identifyNo') ||
            '批次识别单号',
          field: 'identifyNo',
          headerAlign: 'center',
          align: 'left',
          minWidth: 180,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },

        {
          title: this.$l('INDEX.batch_label_outBillType') || '出单类型',
          field: 'v_outBillType',
          headerAlign: 'center',
          align: 'center',
          minWidth: 120,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_dispatchPort') || '发运港口',
          field: 'v_dispatchPort',
          headerAlign: 'center',
          align: 'center',
          minWidth: 130,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_destinationPort') ||
            '目的港口',
          field: 'v_destinationPort',
          headerAlign: 'center',
          align: 'center',
          minWidth: 130,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title:
            this.$l('INDEX.order_form_batch_label_packingType') || '装箱方式',
          field: 'v_packingType',
          headerAlign: 'center',
          align: 'center',
          minWidth: 90,
          showHeaderOverflow: true,
          showOverflow: true,
        },

        {
          title: this.$l('INDEX.order_form_batch_label_totQty') || '产品数',
          field: 'totQty',
          headerAlign: 'center',
          align: 'center',
          minWidth: 100,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'number',
        },
        {
          title: this.$l('INDEX.order_form_batch_label_totBoxQty') || '箱数',
          field: 'totBoxQty',
          headerAlign: 'center',
          align: 'center',
          minWidth: 100,
          showHeaderOverflow: true,
          showOverflow: true,
          sortable: true,
          sortType: 'number',
        },
        {
          title:
            this.$l('INDEX.order_form_label_salesPersonCode') || '业务人员名字',
          field: 'salesPersonName',
          minWidth: 170,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title:
            this.$l('INDEX.order_form_label_bizPersonCode') || '跟单人员名字',
          field: 'bizPersonName',
          minWidth: 170,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.order_form_label_custCode') || '下单客户',
          field: 'custName',
          minWidth: 200,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.table_label_endcustomer_name') || '终端客户',
          field: 'endCustName',
          minWidth: 200,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.order_form_label_scmCode') || '执行工厂',
          field: 'v_scmCode',
          minWidth: 200,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
        },
        {
          title: this.$l('INDEX.order_form_label_orderScmCode') || '名义工厂',
          field: 'v_orderScmCode',
          minWidth: 200,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
        },
      ],
    }
  },
  methods: {
    headerCellStyle({ column }) {
      if (column.property !== 'xxx') {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff',
        }
      }
    },
    getCheckboxRecords() {
      const data = this.$refs.table.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据!!',
          type: 'warning',
        })
        return
      }
      return data
    },
    del(row) {
      this.$emit('delete', [row])
    },
    batchDel() {
      const data = this.getCheckboxRecords()
      if (!data) return
      this.$emit('delete', data)
    },
  },
}
</script>
